/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { dFix, dAdd, dMul, dDiv } from '@/data/Settings';
export { dFix, dAdd, dMul, dDiv };
